import styled from 'styled-components';
import Icon from '../../assets/images/blue-info-icon.svg';

const InfoBlueIcon = styled.span`
  background: url(\"${Icon}\") no-repeat left center;
  background-size: 24px 24px;
  display: block;
  position: relative;
  width: 24px;
  height: 24px;
`;

export default InfoBlueIcon;
